import { render, staticRenderFns } from "./EntityCard.vue?vue&type=template&id=993f6e6a&"
import script from "./EntityCard.vue?vue&type=script&lang=js&"
export * from "./EntityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports